import React, { useEffect } from "react"
import Script from 'next/script'
import { Provider } from 'react-redux'
import type { NextPage } from 'next'
import type { AppProps } from "next/app"
import { Helmet } from 'react-helmet'
import { useRouter } from 'next/router'
// import Head from "next/head"
import '@/plugins/seel-business/asset/css/index.css'
import "src/styles/globals.css"
import { isNode } from "src/utils"
import { supportLanguage } from 'config/i18nConfig'
// import useRem from 'utils/rem'
import 'antd-mobile/es/global'
import store from 'src/redux/store'
import carrier from "@/src/utils/carrier"
import InitStore from "@/src/redux/InitStore"
import { setLang } from "../utils/useI18n"

// 客户端初始化挂载
if (!isNode()) {
  // 挂载运输商
  React.$carrier = carrier
  // 挂载ga分析
  const ga =  require('@/plugins/ga').default
  window.YQMJsBridge = window.YQMJsBridge || {}
  window.YQMJsBridge.ga = ga
  // ga4初始化
  try {
      let gtagId = ''
      //根据当前环境切换ga4统计容器
      if(process.env.APP_ENV==='production'){
          gtagId = 'G-T631DT2SHH' // M站GA4 ID
      }else{
          gtagId = 'G-V4LE7Z0DDV'
      }
      // 初始化T站对应ga4谷歌分析
      window.YQMJsBridge.ga.initGtagGA(gtagId,'',true)
  } catch (e) {
      console.log(e)
  }

  // ga4-Phone
  try {
    if(process.env.APP_ENV==='production'){
      // 全局分享至Phone端、线上才发
      window.gtag('config', 'G-5EF85WDY90', {
        'location_global': window && window.location && window.location.pathname
      })
    }
  } catch (e) { 
      console.log(e)
  }

  // rem初始化
  // useRem()
}

// layout Types
export type NextPageWithLayout<T> = NextPage<T> & {
  getLayout?: (page: React.ReactElement) => React.ReactNode
}

type AppPropsWithLayout = AppProps & {
  Component: NextPageWithLayout<any>
}


function MyApp({ Component, pageProps }: AppPropsWithLayout) {
  const router = useRouter()

  const getLayout = Component.getLayout ?? ((page) => page)
  
  useEffect(() => {
    setLang(router.locale || 'en')
  }, [])
  
  
  return getLayout(
    <>
      <Helmet
        htmlAttributes={{ lang: router.locale }}
        meta={[
          // { charSet: 'utf-8' },
          // { httpEquiv: 'X-UA-Compatible', content: 'IE=edge,chrome=1' },
          // { name: 'viewport',content: 'width=device-width, initial-scale=1, maximum-scale=1, minimum-scale=1, user-scalable=no'},
          // { property: 'og:type', content: 'website' },
          // { property: 'og:url', content: 'https://m.17track.net' },
          // { property: 'og:title', content: '【17TRACK】Tracking Result' },
          // { property: 'og:description', content: '【17TRACK】Tracking Result' },
          // { property: 'og:image', content: 'https://res.17track.net/global-v2/imgs/oauth_image/share.png' },
          // { name: 'description', content: 'IE=edge,chrome=1' },
          // { name: 'theme-color', content: '#FFFFFF' }
        ]}
        link={[
          // { rel: 'apple-touch-icon', content: '/apple-icon.png' },
          { rel:'canonical', href: `https://www.17track.net/${router.locale || 'en'}` },
          { rel:"manifest", href: '/manifest.json' },
          { rel:"shortcut icon", href: '//res.17track.net/global-v2/favicon.ico?v=20170712' },
          { rel:"image_src", href: 'https://res.17track.net/global-v2/imgs/oauth_image/share.png' },
          // { rel: "icon", sizes: '192x192', href: '/asset/images/chromebg.png', color: '#003A9B'},
          { href:"/asset/logo/16x16.png", rel:"icon", type:"image/png", sizes:"16x16"},
          { href:"/asset/logo/32x32.png", rel:"icon", type:"image/png", sizes:"32x32"},
          { rel:"apple-touch-icon", href:"https://res.17track.net/global-v2/imgs/oauth_image/apple_touch_152x152.png", sizes:"152x152"},
          { rel:"apple-touch-icon", href:"https://res.17track.net/global-v2/imgs/oauth_image/apple_touch_144x144.png", sizes:"144x144"},
          { rel:"apple-touch-icon", href:"https://res.17track.net/global-v2/imgs/oauth_image/apple_touch_120x120.png", sizes:"120x120"},
          { rel:"apple-touch-icon", href:"https://res.17track.net/global-v2/imgs/oauth_image/apple_touch_114x114.png", sizes:"114x114"},
          { rel:"apple-touch-icon", href:"https://res.17track.net/global-v2/imgs/oauth_image/apple_touch_76x76.png", sizes:"76x76"},
          { rel:"apple-touch-icon", href:"https://res.17track.net/global-v2/imgs/oauth_image/apple_touch_72x72.png", sizes:"72x72"},
          { rel:"apple-touch-icon", href:"https://res.17track.net/global-v2/imgs/oauth_image/apple_touch_60x60.png", sizes:"60x60"},
          { rel:"apple-touch-icon", href:"https://res.17track.net/global-v2/imgs/oauth_image/apple_touch_57x57.png", sizes:"57x57"}
        ]}
      />
      <Script
        src={`//res.17track.net/asset/carrier/info/indicator.${router.locale}.js`}
        strategy="beforeInteractive"
      />
      <Provider store={store}>
        <InitStore></InitStore>
        <Component {...pageProps} />
      </Provider>
    </>
  ) 
}


export default MyApp
